import React, { useEffect, useState } from 'react'

import { useMediaQuery } from '@mui/material'

import { NextSeo } from 'next-seo'

import { useTheme } from '@mui/material/styles'
import Header from '@/src/components/HeaderV2'
import { useRouter } from 'next/router'

import Footer from '@/src/components/Footer/Footer2'
import FAQPC from '@/src/components/FAQ/FAQPC'
import FAQMobile from '@/src/components/FAQ/FAQMobile'

export async function getStaticProps() {
  const baseUrl = process.env.NEXT_PUBLIC_BASEURL
  const allData = await fetchAllData(baseUrl + 'faq/')
  return { props: { data: allData }, revalidate: 600 }
}
async function fetchAllData(url) {
  let allData = []
  try {
    while (url) {
      url = url.replace('http://', 'https://') //solve CORS
      const res = await fetch(url)
      const data = await res.json()

      // Check for error response from the API
      if (!res.ok) {
        console.error('Error fetching data:', data.detail)
        break
      }

      // Concatenate the data from the current page to the allData array
      allData = [...allData, ...data.results.data]

      // Move to the next page by updating the 'url' variable
      url = data.next
    }
  } catch (error) {
    // Handle any potential errors during the data fetching process
    console.error('Error fetching data:', error)
  }

  return allData
}

export default function FAQ_WRAPPER({ data }) {
  const filteredResults = data.filter(({ is_hidden }) => !is_hidden)

  const filteredData = {
    // only show non-hidden results
    ...data,
    count: filteredResults.length, // update count
    results: {
      data: filteredResults
    }
  }

  return (
    <>
      <NextSeo
        title="FAQ  | Orka - Hear what matters"
        description="Have questions about Orka or your hearing health? We are here for you."
        canonical="https://www.hiorka.com/FAQ"
        openGraph={{
          type: 'website',
          url: 'https://www.hiorka.com/FAQ',
          title: 'FAQ  | Orka - Hear what matters',
          description: 'Have questions about Orka or your hearing health? We are here for you.',
          images: [
            {
              url: '/imgs/productone.png',
              width: 2560,
              height: 1440,
              alt: 'Og Image Alt'
            },
            {
              url: '/imgs/productone2.png',
              width: 1080,
              height: 1080,
              alt: 'Og Image Alt'
            },
            {
              url: '/imgs/productone3.png',
              width: 2004,
              height: 1129,
              alt: 'Og Image Alt'
            }
          ]
        }}
      />
      <Header isWhiteBg isFixed />
      <div>
        <FAQBody data={filteredData} />
        <Footer />
      </div>
    </>
  )
}

const FAQBody = ({ data }) => {
  const router = useRouter()
  const { _ua_device } = router.query

  const [largerThanTablet, setLargerThanTablet] = useState(_ua_device !== 'mobile')
  const theme = useTheme()
  const clientSideLargerThanTablet = useMediaQuery(theme.breakpoints.up('dl'))

  useEffect(() => {
    setLargerThanTablet(clientSideLargerThanTablet)
  })

  if (largerThanTablet) {
    return <FAQPC data={data} />
  } else {
    return <FAQMobile data={data} />
  }
}

export async function getStaticPaths() {
  return {
    paths: [{ params: { _ua_device: 'PC' } }, { params: { _ua_device: 'mobile' } }],
    fallback: false
  }
}
